import React from 'react'
import { BCol, BRow, BTitle } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import { InfoCheckbox } from '../'
import styles from './styles.scss'

import { URL } from '../../constants'

interface Props extends IntlInterface {
  idCard: boolean
  income: boolean
  otherId: boolean
}

export const DocsInfo = ({ idCard, income, otherId, translate }: Props) => (
  <>
    <BTitle type="h3" center>
      {translate(messages.docsInfo.title)}
    </BTitle>

    {idCard && (
      <BRow theme="mb-3">
        <BCol theme="offset-md-2">
          <InfoCheckbox>{translate(messages.docsInfo.idCard)}</InfoCheckbox>
        </BCol>
      </BRow>
    )}

    {otherId && (
      <BRow theme="mb-3">
        <BCol theme="offset-md-2">
          <InfoCheckbox>{translate(messages.docsInfo.otherId)}</InfoCheckbox>
        </BCol>
      </BRow>
    )}

    {income && (
      <BRow theme="mb-5">
        <BCol theme="offset-md-2">
          <InfoCheckbox>
            <a
              className={styles.textLink}
              href={URL.MONETA_INCOME_FORM}
              rel="noopener noreferrer"
              target="_blank">
              {translate(messages.docsInfo.incomeLink)}
            </a>
            &nbsp;
            {translate(messages.docsInfo.income)}
          </InfoCheckbox>
        </BCol>
      </BRow>
    )}
  </>
)

export default intl(DocsInfo)
